'use client';

import React, { FC, useEffect, useRef } from 'react';
import { Box, BoxProps } from '@mantine/core';

import { Container } from '@/../marketing/components/container/Container';

import { useInViewport } from '@mantine/hooks';

import cx from './Section.module.css';

export type SectionProps = {
    id?: string;
    variant?: 'default' | 'light' | 'dark';
    children: React.ReactNode;
    bgGradient?: {
        show?: boolean;
        position?: [string, string]; // in % [x, y]
        size?: string; // in vw
    };
    'data-with-bg'?: string;
} & BoxProps;

const Section: FC<SectionProps> = ({
    id,
    variant = 'default',
    bg,
    children,
    bgGradient = { show: false },
    ...props
}) => {
    const { ref, inViewport } = useInViewport();
    const hasRendered = useRef(false);

    useEffect(() => {
        if (inViewport) {
            hasRendered.current = true;
        }
    }, [inViewport]);

    return (
        <Box
            ref={ref}
            id={id}
            className={`${cx.section}  ${inViewport || hasRendered.current ? cx.visible : ''}`}
            data-variant={variant}
            data-bg={bg}
            data-with-gradient={bgGradient.show}
            style={{
                '--gradient-x': bgGradient.position?.[0] ?? '50%',
                '--gradient-y': bgGradient.position?.[1] ?? '50%',
                '--gradient-size': bgGradient.size ?? '50vw',
                ...props.style,
            }}
            bg={bg}
            {...props}
        >
            <Container padding="xy">{children}</Container>
        </Box>
    );
};

export { Section };
